<template>
	<div id="patient-info-sheet" class="px-2 has-text-left m-4">
		<div class="fullname title is-3">
			{{ patient.firstName }} {{ patient.lastName }}
		</div>
		<div class="grid-box-2 block">
			<div class="block grid-cell-b contact-patient-block">
				<div class="title is-size-6">Contactar con paciente</div>
				<button class="button is-bg-primary" @click="onVideoCallClick">
					Enviar petición de videollamada
				</button>
			</div>

			<div v-if="!patient.hasFilledPersonalInformation">
				Paciente aún no ha completado sus datos
			</div>
			<div v-else class="grid-cell-a">
				<div class="content flex">
					<div class="dni"><div class="label-cell">DNI</div> <span class="value-cell">{{ patient.dni }}</span></div>
					<div class="patient-field-information">
						<div class="label-cell">Fecha Nac.</div> <span class="value-cell">{{ patient.birthDate }}</span>
					</div>
					<div class="patient-field-information">
						<div class="label-cell">Alergias</div>
						<span class="value-cell">{{ allergies }}</span>
					</div>
					<div class="patient-field-information">
						<div class="label-cell">Contacto en caso de emergencia</div>
						<div class="value-cell">
							<div class="pl-3">
								<span class="icon">
									<i class="fas fa-user"></i>
								</span>
								<span>{{ patient.emergencyContact.name }}</span>
							</div>
							<div class="pl-3">
								<span class="icon">
									<i class="fas fa-phone"></i>
								</span>
								<span>{{ patient.emergencyContact.phoneNumber }}</span>
							</div>

						</div>
					</div>
				</div>
			</div>

		</div>
		<div v-if="!patient.hasFilledPersonalInformation">
			Paciente aún no ha completado sus datos
		</div>
		<div v-else class="block">
			<div class="content">
				<span
					class="button"
					@click="showHealthInformation = !showHealthInformation"
				>
					<span class="is-size-5 has-text-weight-bold"
						>Antecedente de salud</span
					>
					<span class="icon is-small">
						<i
							class="fas"
							:class="{
								'fa-chevron-up': showHealthInformation,
								'fa-chevron-down': !showHealthInformation,
							}"
						></i
					></span>
				</span>
			</div>
			<div v-if="showHealthInformation" class="px-3 block">
				<div
					class="patient-field-information"
					v-for="(item, i) in patient.healthBackground"
					:key="'hinfo' + i"
				>
					<span class="py-2">{{ item.question }}</span
					><br />
					<span>{{ item.answer }}</span>
				</div>
			</div>
			<div class="block">
				<div class="title is-size-6">Tomas recomendadas</div>
				<measurement-schedule-list
					:schedules="patient.lastMeasurementSchedule"
					isDoctor
					class="block"
				></measurement-schedule-list>
				<div class="block pb-4">
					<button class="button is-bg-primary" @click="openScheduleForm = true">
						Actualizar rutina
					</button>
					<div class="schedule-form" v-if="openScheduleForm">
						<measurement-schedule-form></measurement-schedule-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { formatDateTime } from "@/domain/entities/EntityFields";
	import { defineComponent, ref } from "vue";
	import MeasurementScheduleForm from "@/components/MeasurementScheduleForm.vue";
	import MeasurementScheduleList from "@/components/MeasurementScheduleList.vue";
	import useDoctor from "@/store/DoctorState";
	import useNotification from "@/store/NotificationState";
	import { useRouter } from "vue-router";
import { MedicalBackground } from "@/domain/entities/MedicalBackground";
import { AllergiesQuestionID } from "@/domain/entities/MedicalQuestion";

	export default defineComponent({
		components: {
			MeasurementScheduleForm,
			MeasurementScheduleList,
		},
		props: {
			patient: Object,
		},
		setup(props) {
			const { sendVideoCallRequest } = useDoctor();
			const { showSnackbar } = useNotification();
			const router = useRouter();
			const openScheduleForm = ref(false);
			const showHealthInformation = ref(false);
			async function onVideoCallClick() {
				try {
					let id = await sendVideoCallRequest();
					router.push({ path: "/call", query: { id } });
				} catch (err) {
					showSnackbar(err);
				}
			}
			const noAllergiesText = 'No tiene alergias';
			let allergies = ref<string>(noAllergiesText);
			let matchedQuestionItems : MedicalBackground[] = props.patient?.healthBackground.filter((hb : MedicalBackground) => hb.question === AllergiesQuestionID);
			if (matchedQuestionItems.length > 0) {
				allergies.value = matchedQuestionItems[0].answer.toUpperCase() === 'SI' ? (matchedQuestionItems[0].extraAnswer || '') : 'No tiene alergias'
			}


			return {
				formatDateTime,
				openScheduleForm,
				onVideoCallClick,
				showHealthInformation,
				allergies,
			};
		},
	});
</script>

<style lang="stylus" scoped>

@import '../styles/colors.styl'

.content.flex
	display grid
	// flex-wrap wrap
	/* min-width: 33.3%; */
	// justify-content space-evenly
	grid-template-columns repeat(auto-fill, minmax(250px, 1fr))
	grid-gap 8px
	margin 0 8px
.content.flex div
	border-radius 8px
	background primaryLightColor
	// min-width 33.3%
	padding-bottom 8px
.label-cell
	padding 8px
	font-weight bold
.value-cell
	margin 0 8px
.grid-box-2
	display grid
	@media screen and (min-width: 768px)
		grid-template-columns auto 300px
.grid-box-2 > .grid-cell-a
	@media screen and (min-width: 768px)
		grid-column 1 / 2
		grid-row 1 / 2
.grid-box-2.grid-cell-b
	@media screen and (min-width: 768px)
		grid-column 2 / 3
		grid-row 1 / 2
.contact-patient-block
	padding 1rem
	border-radius 1rem
	background primaryLightColor
	
</style>